// Persistance générique du BROUILLON d'un formulaire de profil (entreprise ou
// institution financière).
//
// Contexte : ces formulaires gardent leurs saisies dans un state React local
// (`formData`). Sans persistance, tout rafraîchissement de page OU tout
// démontage (changement d'onglet interne qui démonte son contenu, navigation)
// faisait perdre les saisies non encore « Sauvegardées » côté backend. Ce
// module persiste le brouillon dans localStorage pour le restaurer.
//
// Le brouillon est effacé après une sauvegarde/soumission réussie ou une
// annulation explicite. Il est cloisonné par SCOPE (company/institution),
// par entité ET par utilisateur, pour ne jamais mélanger deux profils/comptes.

const PREFIX = 'wanzo_form_draft:';

export type FormDraftScope = 'company' | 'institution';

/**
 * Clé de brouillon cloisonnée par scope + entité (ou 'new' si pas encore
 * créée) + utilisateur.
 */
export function formDraftKey(
  scope: FormDraftScope,
  entityId?: string | null,
  userId?: string | null,
): string {
  return `${PREFIX}${scope}:${entityId || 'new'}:${userId || 'anon'}`;
}

export function saveFormDraft(key: string, data: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  } catch {
    // localStorage indisponible (mode privé, quota) — dégradation silencieuse.
  }
}

export function loadFormDraft<T = unknown>(key: string): T | null {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return (parsed?.data ?? null) as T | null;
  } catch {
    return null;
  }
}

export function clearFormDraft(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
